const validPrimaryActionUrlDomain = /\.{0,1}abpn\.org/i

/**Only URLs within ABPN domain are valid*/
const canNavigateToUrl = (url : string) => {
    return validPrimaryActionUrlDomain.test(url);
}

const isAbsoluteUrl = (url : string) => {
    var absoluteUrlPattern = /^(w{3,}|\w+:){0,1}[^\s]+[\w]\.\w+/i;
    return absoluteUrlPattern.test(url);
}

export { isAbsoluteUrl, canNavigateToUrl };